// mds-dojo — dijit/form/_FormValueWidget — FAITHFUL port of
// references/dijit/form/_FormValueWidget.js. Codemod pipeline; declare from the
// faithful runtime. Adaptation: `dojo/sniff` → `dojo/has` (only has("ie") is read;
// under evergreen it is undefined so the IE7 layout-hack body never runs).
// Base class for widgets corresponding to native HTML elements such as <input> or
// <select> that have user changeable values.
import declare from '../../dojo/_base/declare-runtime'; // declare
import has from '../../dojo/has'; // has("ie")
import _FormWidget from './_FormWidget';
import _FormValueMixin from './_FormValueMixin';

export default declare("dijit.form._FormValueWidget", [_FormWidget, _FormValueMixin], {
	// summary:
	//		Base class for widgets corresponding to native HTML elements such as `<input>` or `<select>`
	//		that have user changeable values.

	// Don't attempt to mixin the 'type', 'name' attributes here programatically -- they must be declared
	// directly in the template as read by the parser in order to function. IE is known to specifically
	// require the 'name' attribute at element creation time.  See #8484, #8660.

	_layoutHackIE7: function () {
		// summary:
		//		Work around table sizing bugs on IE7 by forcing redraw

		if (has("ie") == 7) { // fix IE7 layout bug when the widget is scrolled out of sight
			var domNode = this.domNode;
			var parent = domNode.parentNode;
			var pingNode = domNode.firstChild || domNode; // target node most unlikely to have a custom filter
			var origFilter = pingNode.style.filter; // save custom filter, most likely nothing
			var _this = this;
			while (parent && parent.clientHeight == 0) { // search for parents that haven't rendered yet
				(function ping() {
					var disconnectHandle = _this.connect(parent, "onscroll",
						function () {
							_this.disconnect(disconnectHandle); // only call once
							pingNode.style.filter = (new Date()).getMilliseconds(); // set to anything that's unique
							_this.defer(function () {
								pingNode.style.filter = origFilter;
							}); // restore custom filter, if any
						}
					);
				})();
				parent = parent.parentNode;
			}
		}
	}
});
